import { c as _c } from "react/compiler-runtime";
import BaseLink from "../../base-link/base-link";
import css from "./header-link.module.scss";
import Image from "@/components/common/image/image";
interface IHeaderLink {
  label: string;
  url: string;
  icon?: string;
  ctaId?: string;
  ctaValue?: string;
  relValue?: string;
}
const HeaderLink = props => {
  const $ = _c(12);
  const {
    icon,
    label,
    url
  } = props;
  const t0 = props?.ctaId ?? "";
  const t1 = props?.ctaValue ?? "";
  const t2 = props?.relValue;
  let t3;
  if ($[0] !== icon || $[1] !== label) {
    t3 = icon && <Image src={icon} alt={label} width={20} height={20} />;
    $[0] = icon;
    $[1] = label;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== label) {
    t4 = label && <span className="capitalize">{label}</span>;
    $[3] = label;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== url) {
    t5 = <BaseLink href={url} className={css.headerLink} data-cta-id={t0} data-cta-value={t1} rel={t2}>{t3}{t4}</BaseLink>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = url;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default HeaderLink;